export default {"src":"/_next/static/media/0x6b3595068778dd592e39a122f4f5a5cf09c90fe2.6d8b1f8f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};